import React from 'react';
import AboutDaim from '../AboutDaim/AboutDaim';
import AboutHeader from '../AboutHeader/AboutHeader';
import Team from '../Team/Team';
import eventImg from '../../../images/png/event-bg.jpg';
import Experience from '../../share/Experience/Experience';
import PartyTime from '../PartyTime/PartyTime';
import Review from '../../share/Review/Review';
import AboutAmet from '../AboutAmet/AboutAmet';

const About = () => {
    return (
        <div>
            <AboutHeader />
            <div data-aos="fade-up" data-aos-duration="3000" style={{marginTop: -180}} className="p-5">
                <img style={{borderRadius: 20}} className="w-100" src={eventImg} alt="" />
            </div>
            <Experience/>
            <AboutDaim />
            <PartyTime/>
            <Team />
            <AboutAmet/>
            <Review/>
        </div>
    );
};

export default About;